'use client';

import Link from 'next/link';

const templates = [
  {
    slug: 'weekly-sales-checkin',
    name: 'Weekly Sales Check-in',
    meta: '4 questions · ~10 min · phone',
    blurb: 'Pipeline, blockers, commitments — from every rep, without the forecast meeting.',
    color: '#EF4444',
  },
  {
    slug: 'team-standup',
    name: 'Team Standup',
    meta: '3 questions · ~5 min · room',
    blurb: 'Yesterday, today, blockers. Skip the 9:15.',
    color: '#3B82F6',
  },
  {
    slug: 'dev-team-standup',
    name: 'Dev Team Standup',
    meta: '4 questions · ~5 min · Slack / email',
    blurb: 'Async standup for engineers who hate synchronous standups.',
    color: '#8B5CF6',
  },
  {
    slug: 'employee-satisfaction-pulse',
    name: 'Employee Satisfaction Pulse',
    meta: '4 questions · ~7 min · email / Slack',
    blurb: 'How people are really doing — with trends you can act on.',
    color: '#10B981',
  },
  {
    slug: 'maintenance-crew-checkin',
    name: 'Maintenance Crew Check-in',
    meta: '4 questions · ~5 min · phone',
    blurb: 'Built for the field: no laptop, no app. Tessa just calls.',
    color: '#F59E0B',
  },
];

export default function TemplateShowcaseSection() {
  return (
    <section id="templates" className="py-20 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-13">
          <div className="landing-section-label">Start from a real template</div>
          <h2 className="text-[38px] font-bold tracking-[-1.5px] mb-3.5 text-foreground">
            Five check-ins you could run this week
          </h2>
          <p className="text-[17px] text-muted-foreground max-w-[540px] mx-auto">
            Every question editable. Every cadence yours.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {templates.map((template) => (
            <Link
              key={template.slug}
              href={`/routines/new/${template.slug}`}
              className="bg-card border border-border rounded-[16px] p-7 flex flex-col transition-all hover:-translate-y-1 hover:shadow-md group"
            >
              <div
                className="text-[11px] uppercase tracking-[1px] mb-3 font-space-mono"
                style={{ color: template.color }}
              >
                {template.meta}
              </div>
              <h3 className="text-[19px] font-bold tracking-[-0.3px] mb-2 text-foreground">
                {template.name}
              </h3>
              <p className="text-[14px] text-muted-foreground leading-[1.7] flex-1 mb-5">
                {template.blurb}
              </p>
              <span className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-foreground group-hover:gap-2.5 transition-all">
                Use this template
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
